import { render, staticRenderFns } from "./PaymentReciptReport.vue?vue&type=template&id=06345304"
import script from "./PaymentReciptReport.vue?vue&type=script&lang=js"
export * from "./PaymentReciptReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06345304')) {
      api.createRecord('06345304', component.options)
    } else {
      api.reload('06345304', component.options)
    }
    module.hot.accept("./PaymentReciptReport.vue?vue&type=template&id=06345304", function () {
      api.rerender('06345304', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/reports/PaymentReciptReport.vue"
export default component.exports